/* eslint-disable */
export default {
  activeCall: '当前通话',
} as const;

// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
